<template>
  <b-form @submit.prevent="submit" class="p-5 mt-6 d-flex flex-column justify-content-between">
    <b-form-textarea class="flex-shrink-0 mb-3" name="message" rows="6" required :placeholder="t('Enter your message')"
                     size="sm"></b-form-textarea>

    <div class="d-flex justify-content-center">
      <b-button type="submit" class="rounded-pill bg-grad px-5">{{ t('Submit') }}</b-button>
    </div>

    <div class="d-flex justify-content-around align-items-center">
      <a href="https://wa.me/963953327657" target="_blank">
        <i-whatsapp height="3rem" width="3rem"></i-whatsapp>
      </a>
      <a href="https://t.me/myhirohealth" target="_blank">
        <i-telegram height="3rem" width="3rem"></i-telegram>
      </a>
      <a href="https://m.me/myHirohealth" target="_blank">
        <i-facebook-messenger height="3rem" width="3rem"></i-facebook-messenger>
      </a>
    </div>
  </b-form>
</template>

<script>
import ITelegram from "@/components/Icons/ITelegram";
import IFacebookMessenger from "@/components/Icons/IFacebookMessenger";
import IWhatsapp from "@/components/Icons/IWhatsapp";

export default {
  name: "ContactUs",
  components: {
    ITelegram,
    IFacebookMessenger,
    IWhatsapp
  },
  inject: ['dataRepo'],
  methods: {
    submit(evt) {
      const formData = new FormData(evt.target);

      this.dataRepo.feedBack(formData)
          .catch(err => this.$handleError(err))
          .then(({status}) => {
            if (status) {
              this.$swal.fire({
                text: 'Your message has been sent successfully',
                icon: "success"
              }).then(() => {
                this.$router.go(-1);
              })
            }
          })
    }
  }
}
</script>

<style scoped>

</style>
